import { isIssuerSupported, issuerDefinitions } from '@/constants/issuers';

import { Avatar, AvatarProps } from '../Avatar';

export type IssuerAvatarProps = AvatarProps & {
  /** ID of the token issuer. */
  id?: string;
};

export const issuerAvatarRadius = '32%';

export const IssuerAvatar = (props: IssuerAvatarProps) => {
  const { id, src, size = 24, ...otherProps } = props;

  const fallbackIconSrc = '/images/chains/none.svg';
  const issuerIconSrc =
    src ?? (isIssuerSupported(id) ? issuerDefinitions[id].logo : fallbackIconSrc);

  return (
    <Avatar
      src={issuerIconSrc}
      fallbackSrc={fallbackIconSrc}
      radius={issuerAvatarRadius}
      size={size}
      {...otherProps}
    />
  );
};
